import { render, staticRenderFns } from "./ad-complaint.vue?vue&type=template&id=5982be3e"
import script from "./ad-complaint.vue?vue&type=script&lang=js"
export * from "./ad-complaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports